/* eslint-disable array-callback-return */
import React, {useState, useEffect } from 'react' 
import moment from 'moment';
import dayjs from 'dayjs';
import { BsFillQuestionCircleFill, BsPlusCircle } from 'react-icons/bs'
import { MdEuroSymbol } from 'react-icons/md'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Ads_fulltitle } from '../../../_helpers/ads_fullname';
import 'dayjs/locale/fr.js';
import { frFR } from '@mui/x-date-pickers/locales';
import Tooltip from '@mui/material/Tooltip';
import { FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select,ListSubheader , TextField ,Divider} from '@mui/material';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';

export  function TransformationSasEnSarl(props) {
 
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const StyledTooltip = ({ title, children, ...props }) => (
    <Tooltip
      {...props}
      title={title}
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            background: '#DEE3E2',
            width: '129px',
            padding: '10px',
            color: '#27295B',
            fontSize: '14px',
            fontWeight: '400'
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );

  return (
    <>
      <div className='' >
        <div className='py-6 px-3 sm:px-6' style={{ borderBottom: '0.5px solid #DEE3E2' }}>
          <h1 className='text-lg sm:text-2xl font-black text-primary'>Annonce légale :  {Ads_fulltitle(props.adsname)}</h1>
        </div>

        <div className='mt-4 sm:mt-0 py-3 sm:py-6 px-3 sm:px-6'>
          <h2 className='text-lg sm:text-[22px] font-bold text-primary'>La société</h2>
          <div className='grid grid-cols-12 items-center mt-3 sm:mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>N° SIREN *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7  mr-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full outline-secondary focus:outline-secondary'
                name="rcs_societe" 
                value={props.formData.rcs_societe} 
                onChange={props.handleChange} 
                error={!props.formData.rcs_societe  && props.isSubmitted?true:false}
              /> 
            </div>
          </div>        
          <div className='grid grid-cols-12 items-center mt-3 sm:mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Dénomination *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full outline-secondary focus:outline-secondary'
                name="denomination_societe" 
                value={props.formData.denomination_societe} 
                onChange={props.handleChange}  
                error={!props.formData.denomination_societe  && props.isSubmitted?true:false}
              />
              <StyledTooltip title="Indiquez le nom de la Société tel que mentionné dans les statuts.">
                <div className='p-0 m-0 w-auto'>
                  <BsFillQuestionCircleFill className='text-2xl fill-primary cursor-pointer hover:fill-secondary' />
                </div>
              </StyledTooltip>
            </div>
          </div> 

          <div className='grid grid-cols-12 items-center mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Forme juridique *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-8'>
              
              <FormControl size="small" className='w-full'>
                <InputLabel id="demo-simple-select-label">Choisissez</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Choisissez"
                  id="forme_juridique_societe" 
                  name="forme_juridique_societe"
                  value={props.formData.forme_juridique_societe} 
                  onChange={props.handleChange}  
                  error={!props.formData.forme_juridique_societe  && props.isSubmitted?true:false}
                > 
                  <ListSubheader>Constitution de société commerciale</ListSubheader>
                    <MenuItem value="SARLU">SARL Unipersonnelle (EURL)</MenuItem>
                    <MenuItem value="SARL">Société à responsabilité limitée (SARL)</MenuItem>
                    <MenuItem value="SASU">Société par actions simplifiée unipersonnelle (SASU)</MenuItem>
                    <MenuItem value="SAS">Société par actions simplifiée (SAS)</MenuItem>
                    <MenuItem value="SA">Société anonyme (SA)</MenuItem> 
                    <MenuItem value="SNC">Société en nom collectif (SNC)</MenuItem>
                  
                  <ListSubheader>Constitution d'une société civile</ListSubheader>
                    <MenuItem value="SC">Société civile</MenuItem>
                    <MenuItem value="SCI">Société civile immobilière (SCI)</MenuItem>
                    <MenuItem value="SCCV">Société civile immobilière de construction vente (SCCV ou SCICV)</MenuItem>
                    <MenuItem value="SCM">Société civile de moyens (SCM)</MenuItem>
                    <MenuItem value="SCPI">Société civile de placement immobilier (SCPI)</MenuItem>
                    <MenuItem value="SCP">Société civile professionnelle (SCP)</MenuItem>

                  <ListSubheader>Constitution d'une société libéral</ListSubheader>                  
                    <MenuItem value="SELARL">Société d'exercice libéral a responsabilité limitée (SELARL)</MenuItem>
                    <MenuItem value="SELEURL">Société d'exercice libéral ayant un associé Unique (SELEURL)</MenuItem>
                    <MenuItem value="SELAFA">Société d'exercice libéral sous forme anonyme (SELAFA)</MenuItem>
                    <MenuItem value="SELAS">Société d'exercice libéral par actions simplifiée (SELAS)</MenuItem>
                    <MenuItem value="SELASU">Société d'exercice libéral par actions simplifiée unipersonnelle (SELASU)</MenuItem>
                    <MenuItem value="SELCA">Société d'exercice libéral en commandite par Actions (SELCA)</MenuItem>
                    <MenuItem value="SCEA">Société civile d'exploitation agricole (SCEA)</MenuItem>
                    <MenuItem value="EARL">Exploitation agricole à responsabilité limitée (EARL)</MenuItem>
                    <MenuItem value="GAEC">Groupement agricole d'exploitation en commun (GAEC)</MenuItem>
                    <MenuItem value="GFA">Groupement foncier agricole (GFA)</MenuItem>
                    <MenuItem value="EIRL">Entrepreneur Individuel à Responsabilité Limité</MenuItem>
                    <MenuItem value="SPFPLAS">Société de Participations Financières de Profession Libérale d'Avocats Simplifiée (SPFPLAS)</MenuItem>
                  
                </Select>
              </FormControl>
            </div>
          </div>

          <div className='grid grid-cols-12 items-center mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Capital *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-6 lg:col-span-3 inline-flex items-center gap-2'>

              <FormControl size="small" className='w-full'>
                <OutlinedInput
                  id="outlined-adornment-weight"
                  endAdornment={<InputAdornment position="end"><MdEuroSymbol className='fill-primary' /></InputAdornment>}
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{
                    'aria-label': 'weight',
                  }}
                  name="capital_societe"
                  value={props.formData.capital_societe} 
                  onChange={props.handleChange}  
                  error={!props.formData.capital_societe  && props.isSubmitted?true:false}
                />
              </FormControl>

              

            </div>
          </div>
          <div className='grid grid-cols-12 mt-3 sm:mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Adresse *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="address_societe"
                value={props.formData.address_societe} 
                onChange={props.handleChange}  
                error={!props.formData.address_societe  && props.isSubmitted?true:false}
              />
            </div>
          </div>

          <div className='grid grid-cols-12 mt-3 sm:mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Adresse suite</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="address_suite_societe"
                value={props.formData.address_suite_societe} 
                onChange={props.handleChange}  
                // error={!props.formData.address_societe  && props.isSubmitted?true:false}
              />
            </div>
          </div>

          <div className='grid grid-cols-12 mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Code postal *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="code_postal"  maxLength="5"
                value={props.formData.code_postal} 
                onChange={(e)=>{props.handleChange(e)}}  
                error={!props.formData.code_postal  && props.isSubmitted?true:false}
              />
            </div>
          </div>
          <div className='grid grid-cols-12 mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Ville *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              {/* <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="ville"
                value={props.formData.ville} 
                onChange={props.handleChange}  
                error={!props.formData.ville  && props.isSubmitted?true:false}
              /> */}
              <FormControl size="small" className='w-full'>
                <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Sélectionnez"
                  name="ville_id"
                  value={props.formData.ville_id}                   
                  onChange={props.handleChange}  
                  error={!props.formData.ville  && props.isSubmitted?true:false}
                  
                >
                  {
                    props.formData.villeArr.map((cityVal,cityIndex)=>{
                      return(<MenuItem value={cityVal.id}>{cityVal.city}</MenuItem>)
                    })
                  }

                </Select>
              </FormControl>
            </div>
          </div>
          <div className='grid grid-cols-12 mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Greffe </label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="greffe" 
                value={props.formData.greffe} 
                onChange={props.handleChange} 
              />
            </div>
          </div>
        </div>
        <div className='mt-4 sm:mt-0 py-3 sm:py-6 px-3 sm:px-6'>
          <h2 className='text-lg sm:text-[22px] font-bold text-primary'>Président démissionnaire de la société</h2>
          <p className='text-lg sm:text-[15px] font-bold text-primary'>Actuel président de la société</p>
          <div className='grid grid-cols-12 items-start mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Civilité </label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              <FormControl size="small" className='w-full'>
                <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Sélectionnez"
                  name="civilite"
                  value={props.formData.civilite} 
                  onChange={(e)=>{props.handleChange(e)}}  
                  
                >
                  <MenuItem value={"Mme"}>Madame</MenuItem>
                  <MenuItem value={"M."}>Monsieur</MenuItem>

                </Select>
              </FormControl>
              
            </div>
          </div>

          <div className='grid grid-cols-12 mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Nom *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="nom"
                value={props.formData.nom} 
                onChange={(e)=>{props.handleChange(e)}} 
                error={!props.formData.nom  && props.isSubmitted?true:false}
                
              />
            </div>
          </div>

          <div className='grid grid-cols-12 mt-6 items-center'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Prénom *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="prenom"
                value={props.formData.prenom} 
                onChange={(e)=>{props.handleChange(e)}} 
                error={!props.formData.prenom  && props.isSubmitted?true:false}
              />
            </div>
          </div>
        </div>
        <div className='py-3 sm:py-6 px-3 sm:px-6'>
          <h2 className='text-lg sm:text-[22px] font-bold text-primary'>Transformation SAS-SASU EN SARL-SARLU</h2>
          <div className='grid grid-cols-12 items-center mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Transformation en *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-8'>
              
              <FormControl size="small" className='w-full'>
                <InputLabel id="demo-simple-select-label">Choisir la forme</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Choisissez"
                  id="type_acte" 
                  name="type_acte"
                  value={props.formData.type_acte} 
                  onChange={props.handleChange}  
                  error={!props.formData.type_acte  && props.isSubmitted?true:false}
                > 
                  <MenuItem value="SARL"> Société à responsabilité limitée (SARL)</MenuItem>
                  <MenuItem value="SARL à capital variable"> Société à responsabilité limitée à capital variable</MenuItem>
                 
                </Select>
              </FormControl>
            </div>
          </div>
          <div className={props.formData.type_acte=="SARL à capital variable"?"grid grid-cols-12 mt-6 items-center":"hidden grid-cols-12 mt-6 items-center"} >
          <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Capital initial *</label>
          <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
            <TextField
              hiddenLabel
              id="outlined-size-small"
              size="small"
              className='w-full'
              name="capital_initial"
              onChange={props.handleChange} 
              value={props.formData.capital_initial} 
              error={!props.formData.capital_initial  && props.isSubmitted?true:false}
            />
          </div>
          </div>
          <div className={props.formData.type_acte=="SARL à capital variable"?"grid grid-cols-12 mt-6 items-center":"hidden grid-cols-12 mt-6 items-center"} >
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Capital min. *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="capital_min"
                onChange={props.handleChange} 
                value={props.formData.capital_min} 
                error={!props.formData.capital_min  && props.isSubmitted?true:false}
              />
            </div>
          </div>
          <div className={props.formData.type_acte=="SARL à capital variable"?"grid grid-cols-12 mt-6 items-center":"hidden grid-cols-12 mt-6 items-center"} >
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Capital max. *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
              <TextField
                hiddenLabel
                id="outlined-size-small"
                size="small"
                className='w-full'
                name="capital_max"
                onChange={props.handleChange} 
                value={props.formData.capital_max} 
                error={!props.formData.capital_max  && props.isSubmitted?true:false}
              />
            </div>
          </div>
        </div>

        <div className='py-3 sm:py-6 px-3 sm:px-6'>
          <h2 className='text-lg sm:text-[22px] font-bold text-primary'>Choisir l'organe et la date de la décision</h2>
          
          <div className='grid grid-cols-12 items-center mt-2 sm:mt-6'>
            <label className='col-span-12 sm:col-span-3 my-2 sm:mb-0 text-base font-normal text-black-light'>Par décision *</label>
            <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7'>
              <FormControl size="small" className='w-full'>
                <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="Sélectionnez"
                  id="type_actepardecesion" name="type_actepardecesion"
                  value={props.formData.type_actepardecesion} onChange={props.handleChange}
                  error={!props.formData.type_actepardecesion && props.isSubmitted?true:false}
                >
                  <MenuItem value={"AGO"}>de L'Assemblée Générale Ordinaire</MenuItem>
                  <MenuItem value={"AGE"}>de L'Assemblée Générale Extraordinaire</MenuItem>
                  <MenuItem value={"AGM"}>de L'Assemblée Générale Mixte</MenuItem>
                  <MenuItem value={"Gerant"}>du Gérant</MenuItem>
                  <MenuItem value={"President"}>du Président</MenuItem>
                  <MenuItem value={"Conseil_Administration"}>du Conseil d'Administration</MenuItem>
                  <MenuItem value={"Associe_Unique"}>de L'Associé Unique</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className='grid grid-cols-12 items-center mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Date de l'AG *</label>
            <div className='col-span-12 sm:col-span-9 mr-7 md:mr-0 md:col-span-7 lg:col-span-4'>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr" localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}  >
                <DemoContainer components={['DatePicker']}  >
                  {
                    props.formData.date_typeag?
                    <DatePicker value={dayjs(props.formData.date_typeag)}   name="date_typeag" onChange={(e)=>{props.handleChangeDate(e,"date_typeag")}} format={"DD/MM/YYYY"}                   
                    />
                    :
                    <DatePicker  name="date_typeag"  onChange={(e)=>{props.handleChangeDate(e,"date_typeag")}} format={"DD/MM/YYYY"}                    
                    />
                  }
                  
                </DemoContainer>
              </LocalizationProvider>
            </div>

          </div>
          <div className='grid grid-cols-12 items-center mt-6'>
            <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Date d'effet *</label>
            <div className='col-span-12 sm:col-span-9 mr-7 md:mr-0 md:col-span-7 lg:col-span-4'>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr" localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}  >
                <DemoContainer components={['DatePicker']}  >
                  {
                    props.formData.date_typeeffet?
                    <DatePicker value={dayjs(props.formData.date_typeeffet)}   name="date_typeeffet"   onChange={(e)=>{props.handleChangeDate(e,"date_typeeffet")}}  format={"DD/MM/YYYY"}                  
                    />
                    :
                    <DatePicker  name="date_typeeffet"   onChange={(e)=>{props.handleChangeDate(e,"date_typeeffet")}}   format={"DD/MM/YYYY"}                 
                    />
                  }
                  
                </DemoContainer>
              </LocalizationProvider>
            </div>

          </div>
        </div>
        {/* Gérant */}
        <div className='mt-4 sm:mt-0 py-3 sm:py-6 px-3 sm:px-6'>
        <h2 className='text-lg sm:text-[22px] font-bold text-primary'>Gérant</h2>
        {props.Les_president.map((val,key)=>{
          return <div key={val.index} index={val.index}  >   
            <div className='grid grid-cols-12 items-start mt-3 sm:mt-6'>
              <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Personne *</label>
              <div className='col-span-12 sm:col-span-9 md:col-span-9 md:mr-10 inline-flex items-center gap-2'>
                <FormControl size="small" className='w-full'>
                  <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id={val.index}
                    label="Sélectionnez"
                    name="type_personne"
                    value={val.type_personne} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    error={!val.type_personne  && props.isSubmitted?true:false}
                    index={val.index}
                  >
                    <MenuItem value={"PERSONNE_PHYSIQUE"}>Personne physique</MenuItem>
                    <MenuItem value={"PERSONNE_MORALE"}>Personne morale</MenuItem>

                  </Select>
                </FormControl>
                
                {/* {val.index >0?
                <div className='p-0 m-0 w-auto'>
                    <RemoveCircleRoundedIcon fontSize='large' className='text-3xl  cursor-pointer  fill-secondary' onClick={(e)=>{props.removeForm(val.index,"Associes")}} />
                </div>
                :""} */}
              </div>
              
            </div>
            <div className={val.type_personne === ""?"hidden":""}>
              <div className={val.type_personne === "PERSONNE_MORALE"?"":"hidden"}>      
                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>N° SIREN *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="personne_morale_rcs"
                      value={val.personne_morale_rcs} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                      error={!val.personne_morale_rcs  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>
                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Dénomination *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="personne_morale_denomination"
                      value={val.personne_morale_denomination} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                      error={!val.personne_morale_denomination  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>
                <div className='grid grid-cols-12 items-start mt-6'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Forme juridique *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
                    <FormControl size="small" className='w-full'>
                      <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Sélectionnez"
                        name="personne_morale_forme_juridique"
                        value={val.personne_morale_forme_juridique} 
                        onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}    
                        error={!val.personne_morale_forme_juridique  && props.isSubmitted?true:false}
                        index={val.index}
                      >
                        <MenuItem value={"SAS"}>Société par actions simplifiée (SAS)</MenuItem>
                        <MenuItem value={"SAS à capital variable"}>Société par actions simplifiée à capital variable</MenuItem>
                        <MenuItem value={"SASU"}>Société par actions simplifiée unipersonnelle (SASU)</MenuItem>
                        <MenuItem value={"SASU à capital variable"}>Société par actions simplifiée unipersonnelle à capital variable</MenuItem>
                        <MenuItem value={"SARL"}>Société à responsabilité limitée (SARL)</MenuItem>
                        <MenuItem value={"SARL à capital variable"}>Société à responsabilité limitée à capital variable</MenuItem>
                        <MenuItem value={"SARLU"}>Société à responsabilité limitée à associé unique (SARLU)</MenuItem>
                        <MenuItem value={"SARLU à capitale variable"}>Société à responsabilité limitée à associé unique à capitale variable</MenuItem>
                        <MenuItem value={"SCI"}>Société civile immobilière (SCI)</MenuItem>
                        <MenuItem value={"SCI à capital variable"}>Société civile immobilière à capital variable</MenuItem>
                        <MenuItem value={"SC"}>Société civile</MenuItem>
                        <MenuItem value={"SA"}>Société anonyme (SA)</MenuItem>
                        <MenuItem value={"SA à capital variable"}>Société anonyme à capital variable</MenuItem>
                        <MenuItem value={"SNC"}>Société en nom collectif (SNC)</MenuItem>
                        <MenuItem value={"SNC à capital variable"}>Société en nom collectif à capital variable</MenuItem>
                        <MenuItem value={"SCM"}>Société civile de moyens (SCM)</MenuItem>
                        <MenuItem value={"SCP"}>Société civile professionnelle (SCP)</MenuItem>
                        <MenuItem value={"SCPI"}>Société civile de placement immobilier (SCPI)</MenuItem>
                        <MenuItem value={"SCCV"}>Société civile immobilière de construction vente (SCCV ou SCICV)</MenuItem>
                        <MenuItem value={"SELAFA"}>Société d'exercice libéral sous forme anonyme (SELAFA)</MenuItem>
                        <MenuItem value={"SELAS"}>Société d'exercice libéral par actions simplifiée (SELAS)</MenuItem>
                        <MenuItem value={"SELAS"}>Société d'exercice libéral par actions simplifiée (SELAS)</MenuItem>
                        <MenuItem value={"SELCA"}>Société d'exercice libéral en commandite par Actions (SELCA)</MenuItem>
                        <MenuItem value={"SELARL"}>Société d'exercice libéral a responsabilité limitée (SELARL)</MenuItem>
                        <MenuItem value={"SELEURL"}>Société d'exercice libéral ayant un associé Unique (SELEURL)</MenuItem>
                        <MenuItem value={"SELASU"}>Société d'exercice libéral par actions simplifiée unipersonnelle (SELASU)</MenuItem>
                        <MenuItem value={"SCEA"}>Société civile d'exploitation agricole (SCEA)</MenuItem>
                        <MenuItem value={"EARL"}>Exploitation agricole à responsabilité limitée (EARL)</MenuItem>
                        <MenuItem value={"GAEC"}>Groupement agricole d'exploitation en commun (GAEC)</MenuItem>
                        <MenuItem value={"GFA"}>Groupement foncier agricole (GFA)</MenuItem>
                        <MenuItem value={"EIRL"}>Entrepreneur Individuel à Responsabilité Limité</MenuItem>
                        <MenuItem value={"SPFPLAS"}>Société de Participations Financières de Profession Libérale d'Avocats Simplifiée (SPFPLAS)</MenuItem>
                      </Select>
                    </FormControl>
                    
                  </div>
                </div>
                <div  className={"grid grid-cols-12 items-center mt-6"} >
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Capital *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-6 lg:col-span-3 inline-flex items-center gap-2'>
                    
                    <FormControl size="small" className='w-full'>
                      <OutlinedInput
                        id="outlined-adornment-weight"
                        endAdornment={<InputAdornment position="end"><MdEuroSymbol className='fill-primary' /></InputAdornment>}
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          'aria-label': 'weight',
                        }}
                        name="personne_morale_capital"
                        value={val.personne_morale_capital} 
                        onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                        error={!val.personne_morale_capital  && props.isSubmitted?true:false}
                        index={val.index}
                      />
                    </FormControl>


                  </div>
                </div>
              </div> 
              <div className={val.type_personne === "PERSONNE_PHYSIQUE"?"":"hidden"}>
                <div className='grid grid-cols-12 items-start mt-6'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Civilité *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
                    <FormControl size="small" className='w-full'>
                      <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Sélectionnez"
                        name="civilite_physique"
                        value={val.civilite_physique} 
                        onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                        error={!val.civilite_physique  && props.isSubmitted?true:false}
                        index={val.index}
                        
                      >
                        <MenuItem value={"Mme"}>Madame</MenuItem>
                        <MenuItem value={"M."}>Monsieur</MenuItem>

                      </Select>
                    </FormControl>
                    
                  </div>
                </div>

                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Nom *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="nom_physique"
                      value={val.nom_physique} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                      error={!val.nom_physique  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>

                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Prénom *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="prenom_physique" 
                      value={val.prenom_physique} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                      error={!val.prenom_physique  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>
              </div>
              <div className='grid grid-cols-12 mt-6 items-center'>
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Adresse *</label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="adresse_physique" 
                    value={val.adresse_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                    error={!val.adresse_physique  && props.isSubmitted?true:false}
                    index={val.index}
                  />
                </div>
              </div>
              <div className='grid grid-cols-12 mt-6 items-center'>
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Complément adresse</label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="adresse_suite_physique"
                    value={val.adresse_suite_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    index={val.index}
                  />
                </div>
              </div>
              <div className={val.type_personne === "PERSONNE_PHYSIQUE"?"grid grid-cols-12 mt-6 items-center":"grid-cols-12 mt-6 items-center hidden"} >
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Résidant à l’étranger</label>
                
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <FormControl size="small" className='w-full'>
                    <InputLabel id="resident_etranger-label">Sélectionnez</InputLabel>
                    <Select
                      labelId="demo-resident_etrangerAssociesphysic-label"
                      id="resident_etranger"
                      label="resident_etranger"
                      name="resident_etranger"
                      value={`${val.resident_etranger}`}                         
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                      index={val.index}
                    >
                      <MenuItem value={"Non"} >Non</MenuItem>
                      <MenuItem value={"Oui"} >Oui</MenuItem>

                    </Select>
                  </FormControl>
                </div>
              </div>  

              <div className={val.resident_etranger==="Non"||  val.type_personne === "PERSONNE_MORALE"?'grid grid-cols-12 mt-6 items-center':'hidden grid-cols-12 mt-6 items-center'} >
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Code postal *</label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="code_postal_physique"
                    value={val.code_postal_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    error={!val.code_postal_physique  && props.isSubmitted?true:false}
                    index={val.index}
                  />
                </div>
              </div>

              <div className='grid grid-cols-12 mt-6 items-center'>
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Ville *</label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  {/* <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="ville_physique"
                    value={val.ville_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    error={!val.ville_physique  && props.isSubmitted?true:false}
                    index={val.index}
                  /> */}
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className={val.type_personne === "PERSONNE_PHYSIQUE" && val.resident_etranger=="Oui" ?'w-full':'hidden w-full'}
                    name="ville_physique"
                    value={val.ville_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    error={!val.ville_physique  && props.isSubmitted?true:false}
                    index={val.index}
                  />
                  <FormControl size="small"  className={val.type_personne === "PERSONNE_PHYSIQUE" &&  val.resident_etranger=="Oui"?'hidden w-full':' w-full'} >
                    <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Sélectionnez"
                      name="ville_physique_id"
                      value={val.ville_physique_id} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                      error={!val.ville_physique  && props.isSubmitted?true:false}
                      index={val.index}                      
                    >
                      {
                        val.ville_physiqueArr.map((cityVal,cityIndex)=>{
                          return(<MenuItem value={cityVal.id}>{cityVal.city}</MenuItem>)
                        })
                      }

                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className={val.type_personne === "PERSONNE_PHYSIQUE" && val.resident_etranger==="Oui"?'grid grid-cols-12 mt-6 items-center':'hidden grid-cols-12 mt-6 items-center'}>
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Pays *</label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="pays_physique"
                    value={val.pays_physique} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                    error={!val.pays_physique  && props.isSubmitted?true:false}
                    index={val.index}
                  />
                </div>
              </div>
              <div className={val.type_personne === "PERSONNE_MORALE"?"grid grid-cols-12 mt-6 items-center":"grid-cols-12 mt-6 items-center hidden"} >
                <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Greffe * </label>
                <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                  <TextField
                    hiddenLabel
                    id="outlined-size-small"
                    size="small"
                    className='w-full'
                    name="personne_morale_greffe"
                    value={val.personne_morale_greffe} 
                    onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}   
                    error={!val.personne_morale_greffe  && props.isSubmitted?true:false}
                    index={val.index}
                  />
                </div>
              </div>
              <div className={val.type_personne === "PERSONNE_MORALE"?"":"hidden"}>
                <div className='px-0 group flex items-center gap-2 text-secondary mt-12 '>                   
                  <span className='text-base font-normal'>Représentée par</span>
                </div>
                <div className='grid grid-cols-12 items-start mt-6'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Civilité </label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-4 mr-7 sm:mr-0 inline-flex items-center gap-2'>
                    <FormControl size="small" className='w-full'>
                      <InputLabel id="demo-simple-select-label">Sélectionnez</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Sélectionnez"
                        name="personne_morale_representation_civilite"
                        value={val.personne_morale_representation_civilite} 
                        onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}                            
                        index={val.index}
                        
                      >
                        <MenuItem value={"Mme"}>Madame</MenuItem>
                        <MenuItem value={"M."}>Monsieur</MenuItem>

                      </Select>
                    </FormControl>
                    
                  </div>
                </div>

                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Nom *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="personne_morale_representation_nom" 
                      value={val.personne_morale_representation_nom} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                      error={!val.personne_morale_representation_nom  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>

                <div className='grid grid-cols-12 mt-6 items-center'>
                  <label className='col-span-12 sm:col-span-3 my-1 sm:mb-0 text-base font-normal text-black-light'>Prénom *</label>
                  <div className='col-span-12 sm:col-span-9 md:col-span-7 mr-7 inline-flex items-center gap-2'>
                    <TextField
                      hiddenLabel
                      id="outlined-size-small"
                      size="small"
                      className='w-full'
                      name="personne_morale_representation_prenom" 
                      value={val.personne_morale_representation_prenom} 
                      onChange={(e)=>{props.handleChangeAddForm(e,val.index,"President")}}  
                      error={!val.personne_morale_representation_prenom  && props.isSubmitted?true:false}
                      index={val.index}
                    />
                  </div>
                </div>
              </div>
            </div>
            <Divider className='mb-6 mt-6' variant="middle" />
          </div> 
        })}  
        {/* <div className='px-0 group flex items-center gap-2 text-primary hover:text-secondary mt-12 cursor-pointer' onClick={(e)=>{props.addForm(e,"Associes")}} >
          <BsPlusCircle className='text-3xl ' />
          <span className='text-base font-normal'>Ajouter un associés</span>
        </div> */}

        </div>  
       
    </div>
    </>
  )
}
